import { IBaseUser } from '@mg-platform/users/users-data-access'

export interface IShopUsersResponse {
  users: IBaseUser[]
}
